import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/Jobapplication.css";

const JobApplication = () => {
  const [applications, setApplications] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("jobApplications")) || [];
    setApplications(stored);
  }, []);

  const handleView = (item) => {
    navigate("/hrdashboard/JobApplicationview", { state: { data: item } }); // ✅ Passing candidate data
  };

  return (
    <div className="jas-admin-wrapper">
      <h2 className="jas-admin-title">Applied Candidates List</h2>

      {applications.length === 0 ? (
        <p className="no-data">⚠️ No Candidates have applied yet.</p>
      ) : (
        <div className="jas-table-wrapper">
          <table className="jas-table">
            <thead>
              <tr>
                <th>Photo</th>
                <th>Candidate Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Applied For</th>
                <th>Salary Expectation</th>
                <th>Location</th>
                <th>Resume</th>
                <th>Profile</th>
              </tr>
            </thead>

            <tbody>
              {applications.map((item, i) => (
                <tr key={i}>
                  <td>
                    {item.photo ? (
                      <img
                        src={item.photo}
                        alt="Profile"
                        className="applicant-img"
                      />
                    ) : (
                      "N/A"
                    )}
                  </td>

                  <td>{item.firstName} {item.lastName}</td>
                  <td>{item.email}</td>
                  <td>{item.phone}</td>
                  <td>{item.positionApplied}</td>
                  <td>{item.expectedSalary}</td>
                  <td>{item.location}</td>
                  <td>
                    {item.resume ? (
                      <a href={item.resume} target="_blank" rel="noreferrer">View Resume</a>
                    ) : "N/A"}
                  </td>
                  <td>
                    <button className="jas-view-btn" onClick={() => handleView(item)}>
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      )}
    </div>
  );
};

export default JobApplication;
